import { useQuery } from '@tanstack/react-query'
import { getRevenueAnalytics, getRevenueByRestaurant } from '@/lib/api/admin/analytics'

/**
 * Hook to fetch revenue analytics
 */
export function useRevenueAnalytics(params: {
  startDate: string
  endDate: string
  groupBy?: 'DAY' | 'WEEK' | 'MONTH'
}) {
  return useQuery({
    queryKey: ['admin', 'analytics', 'revenue', params],
    queryFn: () => getRevenueAnalytics(params),
    enabled: !!params.startDate && !!params.endDate,
  })
}

/**
 * Hook to fetch revenue breakdown by restaurant
 */
export function useRevenueByRestaurant() {
  return useQuery({
    queryKey: ['admin', 'analytics', 'revenue-by-restaurant'],
    queryFn: () => getRevenueByRestaurant(),
  })
}
